if($('.in-404').length){
    $('.no-find').html(window.location.href)
}

if ($('.dop-acc').length) {
    $(".dop-acc").click(function() {
      $(this).toggleClass('dop-opened');
    });
}

if($(registrace).length){
  $('.content-wrapper-in main#content').before($('footer#footer .registrace-box').clone());
}